import { css } from 'styled-components';

export default css`
  padding: 10px;
  height: ${({ showModal }) => (showModal ? '70vh' : '80vh')};
  overflow: auto;
  flex-grow: 1;
  .terms-and-conditions-value {
    font-family: 'Work Sans';
    white-space: pre-wrap;
  }
`;
